const LIVE_STATUS_PENDING = 10; // 待直播
const LIVE_STATUS_DOING = 20; // 直播中
const LIVE_STATUS_CLOSED_ANCHOR = 30; // 主播主动关闭
const LIVE_STATUS_CLOSED_CREATER = 40; // 被创建者关闭
const LIVE_STATUS_CLOSED_PLATFORM = 50; // 被平台关闭
const LIVE_STATUS_CLOSED_LATE_ANCHOR = 60; // 主播迟到关闭
const LIVE_STATUS_CLOSED_STREAM_LOST = 70; // 断流关闭
const LIVE_STATUS_CLOSED_TIME_OVER = 80; // 到了直播结束时间关闭
export const liveStatusEnum = {
  LIVE_STATUS_PENDING,
  LIVE_STATUS_DOING,
  LIVE_STATUS_CLOSED_ANCHOR,
  LIVE_STATUS_CLOSED_CREATER,
  LIVE_STATUS_CLOSED_PLATFORM,
  LIVE_STATUS_CLOSED_LATE_ANCHOR,
  LIVE_STATUS_CLOSED_STREAM_LOST,
  LIVE_STATUS_CLOSED_TIME_OVER,
  // list: [
  //   LIVE_STATUS_PENDING,
  //   LIVE_STATUS_DOING,
  //   LIVE_STATUS_CLOSED_ANCHOR,
  //   LIVE_STATUS_CLOSED_CREATER,
  //   LIVE_STATUS_CLOSED_PLATFORM,
  //   LIVE_STATUS_CLOSED_LATE_ANCHOR,
  //   LIVE_STATUS_CLOSED_STREAM_LOST,
  //   LIVE_STATUS_CLOSED_TIME_OVER
  // ],
  endList: [
    LIVE_STATUS_CLOSED_ANCHOR,
    LIVE_STATUS_CLOSED_CREATER,
    LIVE_STATUS_CLOSED_PLATFORM,
    LIVE_STATUS_CLOSED_LATE_ANCHOR,
    LIVE_STATUS_CLOSED_STREAM_LOST,
    LIVE_STATUS_CLOSED_TIME_OVER
  ]
};

// http://wiki.aikucun.xyz/pages/viewpage.action?pageId=4247957
export const textMsgTypes = {
  IM_TEXT: 0,
  TEXT: 1,
  LIVEDATA: 2,
  FORBID: 3,
  NOTICE: 4,
  TURNOVER: 5,
  END: 6,
  SUSPEND: 8,
  ADDGOOD: 9,
  PRODUCT: 10,
  WITHDRAW: 12, // 撤回
  FORWARD: 15, // 电台直播-转发商品消息
  FORWARD_ORDER: 16,  // 电台直播-转发成单通知消息
  FORWARD_DEAL: 17, // 电台直播-转发成单数据

  DRAW_START: 18, // 发起抽奖
  DRAW_UPDATE_TASK: 19, // 完成抽奖任务
  DRAW_JOIN: 20, // 参与抽奖
  DRAW_LUCK: 21, // 中奖
  DRAW_TASK_PROGRESS: 22, // 抽奖任务进度
  DRAW_PUSH: 25, // 推送已经发起过的抽奖

  COUPON_SPECIAL_START: 23, // 主播推送直播专享券
  COUPON_TAKE: 24, // 用户领取优惠券

  // 消息改造
  LIVING_TO_BUY: 26, // 直播中正在去买
  LIVING_BOUGHT: 11, // 直播中成功购买了一单
  LIVING_ADDCART: 27, // 直播中加购
  LIVING_SHARE: 28, // 直播分享
  LIVING_COUPON_MERGE: 29, // 直播中-观众领取了优惠券合并提示
};

export const friendRelaTypes = {
  NoFRIEND: 10,
  FRIEND: 20,
  OWNER: 30
};

export const imEnvType = {
  development: "DEV",
  test1: "TEST1",
  test2: "TEST2",
  stable: "STABLE",
  release: "RELEASE",
  pre: "PRE", // FIXME: IM无预发，使用线上环境
  production: "PROD",
};

// 1饷店普通买家 2饷店店主 3饷店店长  99游客
const XD_USER_ROLE_MORMAL_BUYER = 1;
const XD_USER_ROLE_SHOPKEEPER = 2;
const XD_USER_ROLE_STORE_MANAGER = 3;
const XD_USER_ROLE_VISITOR = 99;
export const xdUserRoleEnum = {
    XD_USER_ROLE_MORMAL_BUYER,
    XD_USER_ROLE_SHOPKEEPER,
    XD_USER_ROLE_STORE_MANAGER,
    XD_USER_ROLE_VISITOR,
    // list: [
    //     XD_USER_ROLE_MORMAL_BUYER,
    //     XD_USER_ROLE_SHOPKEEPER,
    //     XD_USER_ROLE_STORE_MANAGER,
    //     XD_USER_ROLE_VISITOR
    // ]
};

// 1:B，b角色 2:C角色
const XD_USER_TYPE_BB = 1;
const XD_USER_TYPE_C = 2;
export const xdUserTypeEnum = {
    XD_USER_TYPE_BB,
    XD_USER_TYPE_C,
    // list: [
    //   XD_USER_TYPE_BB,
    //   XD_USER_TYPE_C,
    // ]
};

// 商品类型
const PRODUCT_TYPE_NORMAL = 10; // 普通商品
const PRODUCT_TYPE_HAITAO = 20; // 海涛商品

export const productTypeEnum = {
  PRODUCT_TYPE_NORMAL,
  PRODUCT_TYPE_HAITAO
}